import axios from "axios";
import { history } from "stores/store";
import LocalStorageService from "utils/LocalStorageService";
import settings from "utils/settings";
import { requestNewToken } from "actions/auth/requests";

const { apiUrl } = settings;

// LocalstorageService
const localStorageService = LocalStorageService.getService().a;

// Add a request interceptor
axios.interceptors.request.use(
  config => {
    const token = localStorageService.getAccessToken();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    // config.headers['Content-Type'] = 'application/json';
    return config;
  },
  error => {
    Promise.reject(error);
  }
);

// Add a response interceptor
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    const originalRequest = error.config;

    // console.error("localStorageService", localStorageService);
    if (error && error.response && error.response.status) {
      // console.error("originalRequest", originalRequest);
      // console.error("error", error);
      // console.error("error.response", error.response);
      // console.error("error.response.data", error.response.data);
      // console.error("error.response.data.errors", error.response.data.errors);
      // console.error("error.message", error.message);
      if (error.response.status === 401 && originalRequest.url === `${apiUrl}user/refresh`) {
        history.push("/login");
        return Promise.reject(error);
      }

      if (
        error.response.status === 401 &&
        !originalRequest._retry &&
        error.response.headers &&
        error.response.headers["token-expired"] &&
        Boolean(error.response.headers["token-expired"])
      ) {
        originalRequest._retry = true;
        const refreshToken = localStorageService.getRefreshToken();
        const jwtToken = localStorageService.getAccessToken();
        return requestNewToken(jwtToken, refreshToken)
          .then((res) => {
            // console.error("getNewToken", res);
            if (res.status === 200 && res.data && res.data.content) {
              localStorageService.setToken(res.data.content);
              axios.defaults.headers.common.Authorization = `Bearer ${localStorageService.getAccessToken()}`;
              return axios(originalRequest);
            }
          })
          .catch(err => {
            console.error("error", err);
          });
      }
    }

    return Promise.reject(error);
  }
);



// WEBPACK FOOTER //
// ./src/actions/axios-modified.js